
/**
 * Formats a device ID (MAC address) for display
 * @param deviceId The full device ID (MAC address)
 * @param short Whether to return a shortened version
 * @returns Formatted device ID
 */
export const formatDeviceId = (deviceId: string, short: boolean = false): string => {
  if (!deviceId) return 'unknown';
  
  // Handle different MAC address formats
  const cleanId = deviceId.replace(/:/g, '').replace(/-/g, '');
  
  if (short) {
    // Return last 5 characters for short display
    return cleanId.slice(-5);
  }
  
  // Format full MAC with colons for readability
  if (cleanId.length === 12) {
    return cleanId.match(/.{1,2}/g)?.join(':') || deviceId;
  }
  
  // Return original if not in expected format
  return deviceId;
};
